
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentHandler, UIComponentState, UIDataModel } from '../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../toolkit/uicomponentcss';
import { UIComponentView } from '../../toolkit/uicomponentview';
import { CRBTUIComponent, CRBTUIComponentProps } from '../home/crbt/crbtuicomponent';
import { NameTuneListViewModelImpl } from './nametunecard/viewmodel/nametunelistviewmodel';
import { NameTunesCSSStyleImpl } from './nametunescss';
import { NameTunesViewImpl } from './nametunesview';
import { APIModelHandler, APIModel } from '../../toolkit/uicomponentapimodel';
import { NameTunesAPIModelImpl, NameTunesAPIModel } from './nametunesapimodel';
import { RoutingFeatures } from '../navigation/routingfeature';
import { ToneDtoImpl, ToneDto } from '../../../core/dto/tonedto';
import { APIFeatures } from '../../../core/util/apifeatures';
// import { Strings } from '../../../utils/resources/strings';
// import { AlertType } from '../../toolkit/alert/alerttype';

export interface NameTunesComponentProps extends CRBTUIComponentProps {
    searchKey: string;
}

export interface NameTunesComponentHandler extends UIComponentHandler {
    onLoadMore(startIndex: number, offset: number): void;
    onSearchClicked(searchKey: string): void;
    onDataNotLoaded(isNotLoaded: boolean): void;
}

export interface NameTunesComponentState extends UIComponentState {
    // isNoSearchResult: boolean;
    isDataNotLoaded: boolean;
    isEmpty: boolean;
}

export class NameTunesComponent extends CRBTUIComponent<NameTunesComponentProps, NameTunesComponentState>
    implements NameTunesComponentHandler {
    private featuredCategoryListViewModel: NameTuneListViewModelImpl;
    private isLoadMore: boolean = false;

    constructor(props: NameTunesComponentProps) {
        super(props);
        this.featuredCategoryListViewModel = new NameTuneListViewModelImpl(
            this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), props.context, "40px");

        this.featuredCategoryListViewModel.setListDatas([]);

        // this.state = {isDataNotLoaded: false, isEmpty: true, isNoSearchResult: false};
        this.state = { isDataNotLoaded: false, isEmpty: true };
    }

    componentDidMount() {
        (this.getView() as NameTunesViewImpl).showLoader();

        (this.getAPIModel() as NameTunesAPIModel).getNameTunes(this.props.searchKey,
            0, +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"),);
    }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel> {
        return new NameTunesViewImpl(this.featuredCategoryListViewModel, applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle {
        return new NameTunesCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel {
        return new NameTunesAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentWillReceiveProps(nextProps: NameTunesComponentProps) {
        (this.getView() as NameTunesViewImpl).showLoader();
        this.featuredCategoryListViewModel.getListOfDatas().length = 0;
        this.isLoadMore = false;
        this.setState({ isDataNotLoaded: false, isEmpty: true });
        // this.setState({isDataNotLoaded: false, isEmpty: true, isNoSearchResult: false});
        (this.getAPIModel() as NameTunesAPIModel).getNameTunes(nextProps.searchKey,
            0, +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"));
    }

    onDataNotLoaded(isNotLoaded: boolean): void {
        this.setState({ isDataNotLoaded: isNotLoaded });
    }

    onSearchClicked(searchKey: string): void {
        // (this.getAPIModel() as NameTunesAPIModel).getNameTunes(searchKey);

        this.props.routeNextFeature(RoutingFeatures.NAME_TUNES + "?searchkey=" + searchKey, false);
        // this.props.onSearchClicked(searchKey);
    }

    onLoadMore(startIndex: number, offset: number): void {
        this.isLoadMore = true;

        (this.getView() as NameTunesViewImpl).showLoader();

        (this.getAPIModel() as NameTunesAPIModel).getNameTunes(this.props.searchKey, startIndex, offset);

    }
    onSuccess(feature: APIFeatures, description: string, data: any): void {
        (this.getView() as NameTunesViewImpl).dismissLoader();
        this.featuredCategoryListViewModel.getListOfDatas().length = 0;
        (this.featuredCategoryListViewModel.setListDatas(data as ToneDto[]));

        !this.isLoadMore ? this.featuredCategoryListViewModel.resetPaginationState() : (this.getView() as NameTunesViewImpl).updatePaginationCount();
        this.setState({ isEmpty: false, isDataNotLoaded: this.featuredCategoryListViewModel.getListOfDatas().length > 0 ? false : true });

        window.scroll(0, 0);
    }

    onFailure(feature: APIFeatures, description: string, data: any): void {
        (this.getView() as NameTunesViewImpl).dismissLoader();

        if (!this.isLoadMore) {
            this.featuredCategoryListViewModel.getListOfDatas().length = 0;
            this.setState({ isEmpty: false, isDataNotLoaded: true });
        }

        window.scroll(0, 0);
    }

    getListOfTones() {
        let tone1 = new ToneDtoImpl();
        tone1.setId("1");
        tone1.setToneName("1234rsva");
        tone1.setArtistName("987ytrfgbnmk jhgfdsdfghjk jhgfdfghjk ");
        tone1.setImgPath("http://placehold.it/120x120&text=image1");
        tone1.setToneUrl("https://callertunes.etisalat.ae/servlet/MobileStreamMediaServlet?fileId=JP0pty9iYIO9U+4tDVjc3o97SAWzJj1fTO9eb7I7ccCSvtxOpEhxZYt/AgeU5Q39fh+QY4LKw5LfRp5KT5lW1Q==");

        let tone2 = new ToneDtoImpl();
        tone2.setId("2");
        tone2.setToneName("1234rsva");
        tone2.setArtistName("987ytrfgbnmk 87654 87654");
        tone2.setImgPath("http://placehold.it/120x120&text=image2");
        tone2.setToneUrl("https://callertunes.etisalat.ae/servlet/MobileStreamMediaServlet?fileId=JP0pty9iYIO9U+4tDVjc3o97SAWzJj1fTO9eb7I7ccCSvtxOpEhxZYt/AgeU5Q39fh+QY4LKw5LfRp5KT5lW1Q==");


        let tone3 = new ToneDtoImpl();
        tone3.setId("3");
        tone3.setToneName("1234rsva");
        tone3.setArtistName("987ytrfgbnmk9 87659876545678");
        tone3.setImgPath("http://placehold.it/120x120&text=image3");
        tone3.setToneUrl("https://callertunes.etisalat.ae/servlet/MobileStreamMediaServlet?fileId=JP0pty9iYIO9U+4tDVjc3o97SAWzJj1fTO9eb7I7ccCSvtxOpEhxZYt/AgeU5Q39fh+QY4LKw5LfRp5KT5lW1Q==");


        let tone4 = new ToneDtoImpl();
        tone4.setId("4");
        tone4.setToneName("1234rsva");
        tone4.setArtistName("987ytrfgbnmk");
        tone4.setImgPath("http://placehold.it/120x120&text=image4");
        tone4.setToneUrl("https://callertunes.etisalat.ae/servlet/MobileStreamMediaServlet?fileId=JP0pty9iYIO9U+4tDVjc3o97SAWzJj1fTO9eb7I7ccCSvtxOpEhxZYt/AgeU5Q39fh+QY4LKw5LfRp5KT5lW1Q==");


        //     // let tone5 = new ToneDtoImpl();
        //     // tone5.setId("5");
        //     // tone5.setToneName("1234rsva");
        //     // tone5.setArtistName("987ytrfgbnmk");
        //     // tone5.setImgPath("http://placehold.it/120x120&text=image5");

        //     // let tone6 = new ToneDtoImpl();
        //     // tone6.setId("6");
        //     // tone6.setToneName("1234rsva");
        //     // tone6.setArtistName("987ytrfgbnmk");
        //     // tone6.setImgPath("http://placehold.it/120x120&text=image6");

        //     // let tone7 = new ToneDtoImpl();
        //     // tone7.setId("7");
        //     // tone7.setToneName("1234rsva");
        //     // tone7.setArtistName("987ytrfgbnmk");
        //     // tone7.setImgPath("http://placehold.it/120x120&text=image7");

        //     // let tone8 = new ToneDtoImpl();
        //     // tone8.setId("8");
        //     // tone8.setToneName("1234rsva");
        //     // tone8.setArtistName("987ytrfgbnmk");
        //     // tone8.setImgPath("http://placehold.it/120x120&text=image8");
        return [tone1, tone2, tone3, tone4, tone1, tone2, tone3];
    }

}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/nametunescomponent.tsx